<div class="wrapper--spacing-horizontal print-only">
  <div class="avoid-page-break" *ngrxLet="customer$ as customer">
    @if (customer) {
      <agr-value-row [label]="reportForLabel | translate" class="customer">{{ customer.name }}</agr-value-row>
      <agr-value-row *ngrxLet="location$ as location" [label]="'report.locationLabel' | translate"
        >{{ location.street }} {{ location.houseNumber }}
        {{ location.houseNumberAddition }}
      </agr-value-row>
      <agr-value-row *ngrxLet="location$ as location" [label]="'report.cityLabel' | translate">{{ location.postalCode }} {{ location.city }} </agr-value-row>
      <agr-value-row [label]="'report.mobileLabel' | translate">{{ customer.mobileNumber }}</agr-value-row>
      <agr-value-row [label]="'report.telephoneLabel' | translate">{{ customer.phoneNumber }}</agr-value-row>
      <agr-value-row [label]="'report.emailLabel' | translate">{{ customer.emailAddress }}</agr-value-row>
      <agr-value-row [label]="'report.customerNumberLabel' | translate">{{ customer.externalId }}</agr-value-row>
    }
  </div>
  <div class="avoid-page-break" *ngrxLet="loggedInEmployee$ as loggedInEmployee">
    <h2 class="text--h5">{{ 'report.contactTitle' | translate }}</h2>
    @if (loggedInEmployee) {
      <agr-value-row [label]="'report.advisorLabel' | translate">{{ loggedInEmployee.lastName }}, {{ loggedInEmployee.firstName }}</agr-value-row>
      <agr-value-row [label]="'report.mobileLabel' | translate">
        {{ loggedInEmployee.mobilePhoneNumber }}
      </agr-value-row>
      <agr-value-row [label]="'report.emailLabel' | translate">
        {{ loggedInEmployee.emailAddress }}
      </agr-value-row>
    }
  </div>
</div>
